import axios from 'axios';

export default {
  getProfile,
  getDefaultPayment,
  getAddressFromBillingAgreementId,
  login,
  setAndConfirmBillingAgreement
};

export function getProfile(params) {
  return axios.get('/api/amazon/getProfile', { params });
}

export function getDefaultPayment(params) {
  return axios.get('/api/amazon/getDefaultPayment', { params });
}

export function getAddressFromBillingAgreementId(params) {
  return axios.get('/api/amazon/getAddressFromBillingAgreementId', { params });
}

export function login(params) {
  return axios.post('/api/amazon/login', params);
}

export function setAndConfirmBillingAgreement(params) {
  return axios.post('/api/amazon/setAndConfirmBillingAgreement', params);
}
